<template>
    <div>
        <div class="top">
            <div>
                <img src="../../assets/imgs/logo1.png" />
            </div>
        </div>
        <div class="center">
            <div class="logo-left">
                <span>欢迎使用</span>
                <div>
                    <span>爱集微企业招聘平台</span>
                    <img src="../../assets/imgs/background-leftimg.png" />
                </div>
            </div>
            <div class="logo-box">
                <div class="title">忘记密码</div>
                <div class="tab">
                  <h5 @click="tab('phoneForm')" :class="{'active':active==='phoneForm'}">通过手机号找回</h5>
                  <h5 @click="tab('emailForm')" :class="{'active':active==='emailForm'}">通过邮箱找回</h5>
                </div>
                <el-form ref="resetForm" :model="resetForm" :rules="resetRules">
                    <el-form-item class="element-input" prop="account">
                        <el-input v-model="resetForm.account" :placeholder="resetForm.accountPlaceholder" />
                    </el-form-item>
                    <p class="tips">{{resetForm.tips}}</p>
                    <el-form-item class="element-input" prop="code">
                        <div class="element-code">
                            <el-input v-model="resetForm.code" placeholder="请输入您的验证码" />
                            <span @click="getCode">{{code_html}}</span>
                        </div>
                    </el-form-item>
                    <el-form-item class="element-input" prop="password">
                        <el-input type="password" v-model="resetForm.password" placeholder="请输入您的密码" />
                    </el-form-item>
                    <el-form-item class="element-input" prop="confirm_password">
                        <el-input type="password" v-model="resetForm.confirm_password" placeholder="请再次输入您的密码" />
                    </el-form-item>
                    <el-button style="width: 100%;margin-top: 30px;" type="primary" @click.native.prevent="handle">确认重置</el-button>
                </el-form>
            </div>
        </div>
        <div class="bottom">
            <span>Copyright 2007-{{currentYear}}©LaoYaoBa.com™Inc.All rights reserved | 闽ICP备17032949号-2</span>
            <span style="margin-top:6px;">闽公网安备 35020502000344号</span>
        </div>
    </div>
</template>
<script>
import Login from "@/api/Login";
export default {
    data() {
        const validateUsername = (rule, value, callback) => {
            const { type } = this.resetForm;
            let reg,type_value;
            if(type === 1) {
              reg = /^[1][1,2,3,4,5,6,7,8,9][0-9]{9}$/;
              type_value = '手机号';
            }else if(type === 2) {
              reg = /^([a-zA-Z0-9_-]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9_-]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
              type_value = '邮箱';
            }
            if (!value) {
                callback(new Error(`${type_value}不能为空`))
            } else if(!reg.test(value)){
                callback(new Error(`${type_value}格式错误`))
            } else {
                callback()
            }
        }
        const validatePassword = (rule, value, callback) => {
            // 测试
            if (!value) {
                callback(new Error('密码不能为空'))
            } else if(value.length<8){
                callback(new Error('密码至少超过八个字符'))
            } else {
                callback()
            }
        }
        return {
            currentYear: '',
            active: 'phoneForm',
            phoneForm: {
              type: 1,
              accountPlaceholder: '请输入您的手机号',
              tips: '输入手机号后，系统将向账号绑定的手机号发送验证码',
              account: '',code: '',password: '',confirm_password: ''
            },
            emailForm: {
              type: 2,
              accountPlaceholder: '请输入您的邮箱',
              tips: '输入邮箱后，系统将向账号绑定的邮箱发送验证码',
              account: '',code: '',password: '',confirm_password: ''
            },
            flag: true,
            currentTime: 60,
            code_html: '获取验证码',
            interval: null,
            resetForm: {},
            resetRules: {
                account: [{ required: true, trigger: 'blur', validator: validateUsername }],
                code: [{ required: true, trigger: "blur", message: "验证码不能为空", },],
                password: [{ required: true, trigger: 'blur', validator: validatePassword }],
                confirm_password: [{ required: true, trigger: 'blur', validator: validatePassword }]
            }
        };
    },
    created(){
        let date = new Date();
        this.currentYear = date.getFullYear();
    },
    mounted(){
      this.resetForm = this.phoneForm;
    },
    methods: {
        tab(active) {
          this.active = active;
          this.resetForm = this[active];
          this.currentTime = 60;
          this.flag = true;
          this.code_html = '获取验证码';
          clearInterval(this.interval);
          this.$refs['resetForm'].clearValidate();
        },
        getCode() {//获取验证码
          this.$refs.resetForm.validateField('account',valid => {
              if (!valid) {
                  if (this.flag) {
                  this.flag = false;
                  let params = {
                    type: this.resetForm['type'],
                    account: this.resetForm['account']
                  };
                  Login.getCode(params)
                      .then((res) => {
                        this.interval = setInterval(() => {
                          this.currentTime--;
                          this.code_html = this.currentTime + 's' + '后重发';
                          if (this.currentTime <= 0) {
                            clearInterval(this.interval);
                            this.code_html = '重新发送';
                            this.currentTime = 60;
                            this.flag = true;
                          }
                        }, 1000);
                      }).catch((err) => {
                        this.flag = true;
                        this.$message.error(err.data.error);
                      });
                }
              } else {
                  console.log('error submit!!')
                  return false
              }
          })
        },

        handle() {
            this.$refs.resetForm.validate(valid => {
            if (valid) {
                    let params = {
                      account: this.resetForm['account'],
                      type: this.resetForm['type'],
                      code: this.resetForm['code'],
                      password: this.resetForm['password'],
                      confirm_password: this.resetForm['confirm_password'],
                    }
                    Login.resetPwd(params)
                      .then((res) => {
                        if(res.data.status === 0){
                          this.$confirm('密码已重置, 是否登录?', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                          }).then(() => {
                            this.$router.push({
                                path:"/login"
                            })
                          })
                        }else{
                          this.$message.error('密码重置失败');
                        }
                      }).catch((err) => {
                        this.$message.error(err.data.error);
                      });
                } else {
                    console.log('error submit!!')
                    return false
                }
            })
        }
    },

}
</script>
<style scoped>
    .tab{
      display: flex;
      margin-bottom: 12px;
    }
    .tab h5{
      flex: 1;
      text-align: center;
      font-size: 14px;
      font-family: MicrosoftYaHei;
      color: #666666;
      cursor: pointer;
    }
    .tab h5:hover{
      font-weight: bold;
      color: #0077FF;
    }
    .tab .active{
      font-weight: bold;
      color: #0077FF;
    }
    .tips{
      font-size: 12px;
      font-family: MicrosoftYaHei;
      color: #FF3F1D;
      line-height: 15px;
      margin-bottom: 4px;
    }
    .element-code{
      position: relative;
    }
    .element-code /deep/ input{
       padding-right: 100px;
    }
    .element-code span{
       position: absolute;
       right: 12px;
       top: 0;
       font-size: 14px;
       font-family: MicrosoftYaHei;
       color: #0077FF;
       cursor: pointer;
    }
    .top{
        height: 72px;
        background-color: #fff;
        -webkit-box-shadow: 0 0 4px #ddd;
        box-shadow: 0 0 4px #ddd;
    }
    .top div{
        max-width: 1200px;
        height: 100%;
        margin: 0 auto;
        display: flex;
        display: -webkit-flex;
        align-items: center;
        -webkit-align-items: center;
    }
    .center{
        min-height: 421px;
        height: calc(100vh - 278px);
        background: url('../../assets/imgs/banckground-img.png');
        background-repeat: no-repeat;
        background-position: center center;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        -webkit-justify-content: center;
        align-items: center;
        -webkit-align-items: center;
    }
    .logo-left{
        position: relative;
    }
    .logo-left>span{
        position: absolute;
        left: 87px;
        height:32px;
        font-size:24px;
        color:#666666;
        line-height:32px;
        letter-spacing:1px;
    }
    .logo-left>div{
        margin-top: 27px;
        position: relative;
        min-width: 560px;
    }
    .logo-left>div>span{
        position: absolute;
        left: 87px;
        top: 13px;
        height:36px;
        font-size:27px;
        font-weight:bold;
        color:#0077FF;
        line-height:36px;
        letter-spacing:1px;
    }
    .logo-box{
        background:rgba(255,255,255,1);
        border-radius:5px;
        margin-left: 27px;
        padding: 30px 25px;
    }
    .logo-box .title{
        font-size:16px;
        color:#333333;
        line-height:21px;
        margin-bottom: 20px;
    }
    .logo-box .checkbox{
        display: flex;
        display: -webkit-flex;
        justify-content: space-between;
        -webkit-justify-content: space-between;
        font-size:12px;
        color:#FF1935;
        line-height:16px;
    }
    .logo-box .checkbox .forgot-pwd{
        font-size: 12px;
        font-family: MicrosoftYaHei;
        color: #0077FF;
        cursor: pointer;
    }
    .element-input{
        width: 287px;
        height: 42px;
        margin-bottom: 15px;
    }
    .bottom{
        height: 206px;
        display: flex;
        display: -webkit-flex;
        flex-direction: column;
        -webkit-flex-direction: column;
        justify-content: center;
        -webkit-justify-content: center;
        text-align: center;
        font-size:12px;
        color:#333333;
        line-height:16px;
    }
</style>
<style>
    .el-checkbox__label{
        font-size:12px!important;
    }
</style>



// WEBPACK FOOTER //
// src/views/my/forgotpwd.vue